import { IonCol } from '@ionic/react';
import React from 'react';
import { MonitoringDevice } from '../../components/MonitoringDevice';
import { BaseSection } from '../BaseSection';

export const MonitoringDeviceSection: React.FC = () => {
  return (
    <BaseSection title="Monitoring Device">
      <IonCol>
        <MonitoringDevice />
      </IonCol>
    </BaseSection>
  );
};
